(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3811],{

/***/ 16563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Clients_Clients; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Clients/Clients.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Wrapper",
  componentId: "sc-1992s35-0"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(50));
var Clients = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Clients",
  componentId: "sc-1992s35-1"
})(["display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;"]);
var Client = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Client",
  componentId: "sc-1992s35-2"
})(["display:flex;justify-content:center;align-items:center;padding:", ";padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40));
var ClientImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Clientselements__ClientImage",
  componentId: "sc-1992s35-3"
})(["width:", ";margin:0 auto;"], (0,polished_esm/* rem */.hO)(130));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Clients/Clients.tsx










var ClientsTemplate = function ClientsTemplate(_ref) {
  var titleKey = _ref.titleKey,
      showClients = _ref.showClients,
      showPartners = _ref.showPartners;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(0),
      visibleKey = _useState[0],
      setVisibleKey = _useState[1];

  (0,useScrollToSection/* default */.Z)('nasi-partneri', 'partneri');
  var clients = ['/italians_logo.png', '/valeo_logo.png', '/keramtech_logo.png', '/safran_logo.png', '/hyundai_logo.png', '/nexen_logo.png', '/danfos_logo.png'];
  var partners = ['/skoleni_logo.png', '/grada_logo.png', '/sagit_logo.png', '/educity_logo.png', '/dane-pro-lidi.jpg', '/mzdy-pro-lidi.jpg', '/sluto.jpg'];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    id: "partneri",
    mobileSidePadding: 20,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        isBlack: true,
        children: t(titleKey)
      }), showClients && /*#__PURE__*/(0,jsx_runtime.jsx)(Clients, {
        children: clients.map(function (client, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Client, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClientImage, {
              src: (0,url_utils/* publicAssets */.VK)(client)
            })
          }, index);
        })
      }), showPartners && /*#__PURE__*/(0,jsx_runtime.jsx)(Clients, {
        children: partners.map(function (partner, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Client, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClientImage, {
              src: (0,url_utils/* publicAssets */.VK)(partner)
            })
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var Clients_Clients = (ClientsTemplate);

/***/ }),

/***/ 1061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(92879);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(23955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__Wrapper",
  componentId: "sc-14sd62t-0"
})(["display:flex;align-items:center;justify-content:center;flex-wrap:wrap;"]);
var PicWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__PicWrapper",
  componentId: "sc-14sd62t-1"
})(["margin:", ";width:90%;@media (min-width:", "px){width:40%;}@media (min-width:", "px){width:30%;}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg);
var PicSource = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Galleryelements__PicSource",
  componentId: "sc-14sd62t-2"
})(["width:100%;cursor:pointer;border-radius:", ";"], (0,polished_esm/* rem */.hO)(16));
var Gallery_elements_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Galleryelements__Title",
  componentId: "sc-14sd62t-3"
})(["font-weight:", ";font-size:", ";width:100%;text-align:center;margin-top:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.tsx













var GalleryTemplate = function GalleryTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var CompanyCoursesImage = [(0,url_utils/* publicAssets */.VK)('/events1.webp'), (0,url_utils/* publicAssets */.VK)('/events6.webp'), (0,url_utils/* publicAssets */.VK)('/events2.webp'), (0,url_utils/* publicAssets */.VK)('/events3.webp'), (0,url_utils/* publicAssets */.VK)('/events5.webp'), (0,url_utils/* publicAssets */.VK)('/events4.webp')];
  var AboutUsImage = [(0,url_utils/* publicAssets */.VK)('/about6.webp'), (0,url_utils/* publicAssets */.VK)('/about1.webp'), (0,url_utils/* publicAssets */.VK)('/about3.webp'), (0,url_utils/* publicAssets */.VK)('/about4.webp'), (0,url_utils/* publicAssets */.VK)('/about2.webp'), (0,url_utils/* publicAssets */.VK)('/about5.webp')];

  var _useState = (0,react.useState)(false),
      showAll = _useState[0],
      setShowAll = _useState[1];

  var _useState2 = (0,react.useState)(false),
      imgFocus = _useState2[0],
      setImgFocus = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      imgIndex = _useState3[0],
      setImgIndex = _useState3[1];

  var _useState4 = (0,react.useState)(router.pathname.includes(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US) ? AboutUsImage : CompanyCoursesImage),
      images = _useState4[0],
      setImages = _useState4[1];

  var minImgShowCount = 6;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H3 */.Z.H3,
      isBlack: true,
      children: t('about.gallery.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: images.map(function (img, index) {
        return showAll || index < minImgShowCount ? /*#__PURE__*/(0,jsx_runtime.jsx)(PicWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PicSource, {
            src: img,
            onClick: function onClick() {
              setImgIndex(index);
              setImgFocus(true);
            }
          })
        }, index) : null;
      })
    }), imgFocus && /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
      mainSrc: images[imgIndex],
      nextSrc: images[(imgIndex + 1) % images.length],
      prevSrc: images[(imgIndex + images.length - 1) % images.length],
      onCloseRequest: function onCloseRequest() {
        return setImgFocus(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setImgIndex((imgIndex + images.length - 1) % images.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setImgIndex((imgIndex + 1) % images.length);
      }
    })]
  });
};

/* harmony default export */ var Gallery = (GalleryTemplate);

/***/ }),

/***/ 59922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49642);





var useScrollToSection = function useScrollToSection(sectionNameInPathname, sectionIdInHtml) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.asPath.includes(sectionNameInPathname)) {
      var element = document.getElementById(sectionIdInHtml);
      return window.scrollTo({
        top: element.offsetTop - (window.innerWidth > _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.sm */ .A.sm ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .DESKTOP_HEADER_HEIGHT */ .cf : _constants__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_HEADER_HEIGHT */ .ZQ),
        behavior: 'smooth'
      });
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToSection);

/***/ }),

/***/ 65253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ o_firme; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Clients/Clients.tsx + 1 modules
var Clients = __webpack_require__(16563);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CompanyValues/CompanyValues.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__Wrapper",
  componentId: "sc-1yc5dv8-0"
})(["margin-top:", ";padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Sections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__Sections",
  componentId: "sc-1yc5dv8-1"
})(["font-size:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:45%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__Section",
  componentId: "sc-1yc5dv8-2"
})(["margin-bottom:", ";", ";", ";", ";"], (0,polished_esm/* rem */.hO)(40), function (prop) {
  return prop.isMission ? "border: 1px solid ".concat(prop.theme.colors.border) : '';
}, function (prop) {
  return prop.isMission ? "border-radius: ".concat((0,polished_esm/* rem */.hO)(16)) : '';
}, function (prop) {
  return prop.isMission ? "padding: ".concat((0,polished_esm/* rem */.hO)(20), " ").concat((0,polished_esm/* rem */.hO)(10)) : '';
});
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__SectionHeader",
  componentId: "sc-1yc5dv8-3"
})(["display:flex;flex-direction:row;align-items:center;font-weight:", ";font-family:", ";", ";", ";svg{margin-right:", ";width:", ";height:", ";path{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.isMission ? "color: ".concat(prop.theme.colors.primary) : '';
}, function (prop) {
  return prop.isMission ? "padding-left: ".concat((0,polished_esm/* rem */.hO)(25)) : '';
}, (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__SectionDescription",
  componentId: "sc-1yc5dv8-4"
})(["padding-top:", ";margin-left:", ";color:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CompanyValues/CompanyValues.tsx










var CompanyValuesTemplate = function CompanyValuesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('about.companyValues.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section1.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section1.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section2.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section2.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section3.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section3.description')
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section4.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section4.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section5.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section5.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          isMission: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionHeader, {
            isMission: true,
            children: t('about.companyValues.section6.label')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section6.description')
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var CompanyValues = (CompanyValuesTemplate);
;// CONCATENATED MODULE: ./src/components/Customers/Customers.elements.tsx



var Customers_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Customerselements__Wrapper",
  componentId: "sc-hjeup7-0"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(50));
var Customers = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Customerselements__Customers",
  componentId: "sc-hjeup7-1"
})(["display:grid;grid-auto-rows:1fr;grid-template-columns:1fr;@media (min-width:", "px){grid-template-columns:1fr 1fr;}@media (min-width:", "px){grid-template-columns:1fr 1fr 1fr;}"], theme/* breakpoints.xs */.A.xs, theme/* breakpoints.sm */.A.sm);
var Customer = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "Customerselements__Customer",
  componentId: "sc-hjeup7-2"
})(["margin-bottom:", ";color:", ";@media (min-width:", "px){margin-left:15%;}"], (0,polished_esm/* rem */.hO)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
}, theme/* breakpoints.xs */.A.xs);
var ShowMoreButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Customerselements__ShowMoreButton",
  componentId: "sc-hjeup7-3"
})(["padding:0;background:none;border:none;cursor:pointer;width:100%;text-decoration:underline;color:", ";font-size:", ";margin-top:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
;// CONCATENATED MODULE: ./src/components/Customers/Customers.tsx








var DEFAULT_COUNT_OF_VISIBLE_CUSTOMERS = 21;

var CustomersTemplate = function CustomersTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(21),
      countOfVisibleCustomers = _useState[0],
      setCountOfVisibleCustomer = _useState[1];

  (0,useScrollToSection/* default */.Z)('reference', 'klienti');
  var customers = ['Asseco Solutions, a. s.', 'Adler Czech, a. s.', 'BOSCH DIESEL, s. r. o.', 'Česká národní banka', 'Česká spořitelna, a. s.', 'ČEZ, a. s.', 'ČSOB pojišťovna, a. s.', 'AFSI Europe s. r. o.', 'AGC Automotive Czech a. s.', 'Agentura pro podporu podnikání a investic CzechInvest', 'ArcelorMittal FCE CZ s. r. o.', 'AUMA - Servopohony spol. s r. o.', 'Auto-Kabel Krupka, s. r. o.', 'AŽD Praha s. r. o.', 'B. Braun Medical s. r. o.', 'BAEST, a. s.', 'BENTELER ČR s. r. o.', 'BRISK Tábor, a. s.', 'Bystronic Czech Republic s.r.o.', 'Callida, s. r. o.', 'ComAp a.s.', 'Crede Experto Praha spol. s r. o.', 'ČEPRO, a. s.', 'ČEPS, a. s.', 'Česká pojišťovna, a. s.', 'Česká republika - Ministerstvo vnitra', 'ČESKÁ TELEVIZE', 'Česká zemědělská univerzita v Praze', 'České aerolinie a. s.', 'Českomoravská stavební spořitelna, a. s.', 'Českomoravská záruční a rozvojová banka, a. s.', 'Československá obchodní banka, a.s.', 'Český Aeroholding, a. s.', 'Český plynárenský svaz', 'Český rozhlas', 'ČEZ ICT Services, a. s.', 'ČEZ Korporátní služby, s. r. o.', 'ČSOB Leasing, a. s.', 'Denso Manufacturing Czech s. r. o.', 'Devro, s. r. o.', 'DONALDSON CZECH REPUBLIC s. r. o.', 'Donaldson Industrial CR - koncern s.r.o.', 'Doosan Bobcat Manufacturing s. r. o.', 'Driessen Aerospace CZ s. r. o.', 'DURA Automotive CZ, k. s.', 'Eberspächer spol. s r. o.', 'EGE, spol. s r. o.', 'Ernst & Young, s. r. o.', 'Geis CZ s. r. o.', 'Husqvarna Česko s. r. o.', 'Kaufland Česká republika v. o. s.', 'Kooperativa pojišťovna, a.s.', 'Metrostav a. s.', 'OMV Česká republika, s. r. o.', 'Energetické opravny, a. s.', 'Engel strojírenská spol. s r. o.', 'Exportní garanční a pojišťovací společnost a. s.', 'Faurecia Emissions Control Technologies Mladá Boleslav, s. r. o.', 'Fibertex Nonwovens, a. s.', 'FTE automotive Czechia s. r. o.', 'GEFCO Česká republika s. r. o.', 'GRAMMER CZ, s. r. o.', 'GRUPO ANTOLIN TURNOV s. r. o.', 'HDS Retail Czech Republic, a. s.', 'Hlavní město Praha', 'HM Studio a. s.', 'INISOFT s. r. o.', 'InterScreen, s. r. o.', 'JABLOTRON ALARMS a. s.', 'Johnson Controls Autobaterie spol. s r. o.', 'Johnson Controls Automobilové součástky k. s.', 'Kalora a. s.', 'KLEPIERRE MANAGEMENT ČESKÁ REPUBLIKA s. r. o.', 'Komerční banka, a. s.', 'Krajská správa a údržba silnic Vysočiny, příspěvková organizace', 'KS - Europe, s. r. o.', 'KS Kolbenschmidt Czech Republic, a. s.', 'MARSH s. r. o.', 'Mercedes-Benz Financial Services Česká republika s. r. o.', 'Městská policie hl. m. Prahy', 'Ministerstvo financí ČR', 'Ministerstvo pro místní rozvoj ČR', 'Ministerstvo školství, mládeže a tělovýchovy', 'Ministerstvo zemědělství ČR', 'MOSER, a. s.', 'Nemocnice Na Homolce', 'Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví', 'Ochranný svaz autorský pro práva k dílům hudebním, o. s.', 'Otavské strojírny a. s.', 'Pacific Direct s. r. o.', 'Panasonic Liquid Crystal Display Czech, s. r. o.', 'PEPSICO CZ, s. r. o.', 'Pozemkový fond České republiky', 'PPF a. s.', 'Schenker, spol. s r. o.', 'Siemens, s. r. o.', 'Skanska a. s.', 'ŠKODA AUTO a. s.', 'Telefónica Czech Republic, a. s.', 'Tesco Stores ČR, a. s.', 'UPC Česká republika, s. r. o.', 'Pražská energetika, a. s.', 'Pražská teplárenská a. s.', 'PWO UNITOOLS CZ a. s.', 'Robert Bosch odbytová s. r. o.', 'Robert Bosch spol. s r. o.', 'RODENSTOCK ČR s. r. o.', 'Rodinný pivovar Bernard a. s.', 'ROHDE & SCHWARZ - Praha, s.r.o.', 'Roche, s. r. o.', 'Rudolf Kämpf s.r.o.', 'RWE GasNet, s. r. o.', 'RWE Interní služby, s. r. o.', 'RWE Transgas, a. s.', 'Řízení letového provozu ČR, s. p.', 'SAFINA, a. s.', 'SAS Autosystemtechnik s. r. o.', 'Sellier & Bellot a. s.', 'SENCO PŘÍBRAM spol. s r. o.', 'Severočeské doly a. s.', 'SMP CZ, a. s.', 'Spojené kartáčovny a. s.', 'Státní fond životního prostředí ČR', 'Státní zemědělský intervenční fond', 'STAVIMEX Praha, a. s.', 'Svaz českých a moravských výrobních družstev', 'ŠKO-ENERGO, s. r. o.', 'TEDOM a. s.', 'TESCO STORES SR, a. s.', 'TI Group Automotive Systems s. r. o.', 'Toyoda Gosei Czech, s. r. o.', 'Travelex Czech Republic a. s.', 'ÚJV Řež, a. s.', 'UNIPETROL RPA, s. r. o.', 'UNIPETROL SERVICES, s. r. o.', 'VALEO AUTOKLIMATIZACE k. s.', 'VIAMONT, a. s.', 'Všeobecná zdravotní pojišťovna ČR', 'Wolters Kluwer ČR, a. s.', 'Zentiva Group, a. s.', 'ZENTIVA, k. s.'];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    id: "klienti",
    mobileSidePadding: 20,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Customers_elements_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        isBlack: true,
        children: t('about.customers.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Customers, {
        children: customers.slice(0, countOfVisibleCustomers).map(function (customer, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Customer, {
            children: customer
          }, key);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShowMoreButton, {
        onClick: function onClick() {
          return countOfVisibleCustomers === (customers === null || customers === void 0 ? void 0 : customers.length) ? setCountOfVisibleCustomer(DEFAULT_COUNT_OF_VISIBLE_CUSTOMERS) : setCountOfVisibleCustomer(customers.length);
        },
        children: countOfVisibleCustomers === (customers === null || customers === void 0 ? void 0 : customers.length) ? t('about.customers.button.showLess') : t('about.customers.button.showMore')
      })]
    })
  });
};

/* harmony default export */ var Customers_Customers = (CustomersTemplate);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ./src/components/Education/Education.elements.tsx



var Education_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Wrapper",
  componentId: "sc-103doc9-0"
})(["padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md);
var Areas = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Areas",
  componentId: "sc-103doc9-1"
})(["padding:0 ", ";margin-top:", ";@media (min-width:", "px){display:flex;flex-direction:row;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.xs */.A.xs, theme/* breakpoints.md */.A.md);
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Column",
  componentId: "sc-103doc9-2"
})(["display:flex;flex-direction:column;@media (min-width:", "px){width:", ";}"], theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(300));
var Area = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Educationelements__Area",
  componentId: "sc-103doc9-3"
})(["display:flex;flex-direction:row;align-items:center;font-size:", ";line-height:", ";color:", ";margin-bottom:", ";padding-right:", ";svg{width:", ";height:", ";margin-right:", ";margin-bottom:", ";g line,polyline{stroke:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(25), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(-2), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grey;
});
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Educationelements__Image",
  componentId: "sc-103doc9-4"
})(["display:block;width:100%;margin-top:", ";@media (min-width:", "px){width:40%;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Education_elements_ShowMoreButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Educationelements__ShowMoreButton",
  componentId: "sc-103doc9-5"
})(["background:none;border:none;cursor:pointer;width:100%;text-decoration:underline;color:", ";text-align:left;padding:0 0 0 ", ";margin-top:", ";@media (min-width:", "px){display:none;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.xs */.A.xs);
;// CONCATENATED MODULE: ./src/components/Education/Education.tsx











var EducationTemplate = function EducationTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(true),
      showAllEducations = _useState[0],
      setShowAllEducations = _useState[1];

  (0,react.useEffect)(function () {
    if (window.innerWidth < 480) {
      setShowAllEducations(false);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Education_elements_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
          tagType: Title/* TitleTagTypes.H2 */.Z.H2,
          alignLeft: true,
          isBlack: true,
          children: t('about.education.title')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Areas, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area1')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area2')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area3')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area4')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area5')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area6')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area7')]
            })]
          }), showAllEducations && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area8')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area9')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area10')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area11')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area12')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area13')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area14')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area15')]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Education_elements_ShowMoreButton, {
          onClick: function onClick() {
            return setShowAllEducations(!showAllEducations);
          },
          children: showAllEducations ? t('about.customers.button.showLess') : t('about.customers.button.showMore')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)('/education.svg')
      })]
    })
  });
};

/* harmony default export */ var Education = (EducationTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(57130);
// EXTERNAL MODULE: ./src/components/Gallery/Gallery.tsx + 1 modules
var Gallery = __webpack_require__(1061);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/components/TrainingTypes/TrainingTypes.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingTypeselements__Background",
  componentId: "sc-1jnzgue-0"
})(["background:rgba(116,120,129,0.08);padding:", " ", ";"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(20));
var TrainingTypes_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingTypeselements__Wrapper",
  componentId: "sc-1jnzgue-1"
})(["display:flex;flex-direction:column;gap:", ";margin-top:", ";@media (min-width:", "px){flex-direction:row;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm);
var TrainingTypes_elements_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingTypeselements__Section",
  componentId: "sc-1jnzgue-2"
})(["background:", ";border-radius:", ";padding:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:50%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm);
var TrainingTypes_elements_SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingTypeselements__SectionHeader",
  componentId: "sc-1jnzgue-3"
})(["font-size:", ";line-height:", ";padding-bottom:", ";font-weight:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(10), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
});
var TrainingTypes_elements_SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingTypeselements__SectionDescription",
  componentId: "sc-1jnzgue-4"
})(["padding-top:", ";color:", ";line-height:", ";font-size:", ";line-height:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(15), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(35));
var SectionButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingTypeselements__SectionButton",
  componentId: "sc-1jnzgue-5"
})(["margin-top:auto;"]);
;// CONCATENATED MODULE: ./src/components/TrainingTypes/TrainingTypes.tsx











var TrainingTypesTemplate = function TrainingTypesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H2 */.Z.H2,
        withoutPadding: true,
        isBlack: true,
        children: t('about.coursesType.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingTypes_elements_Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingTypes_elements_Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TrainingTypes_elements_SectionHeader, {
            children: t('about.coursesType.section1.label')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingTypes_elements_SectionDescription, {
            children: t('about.coursesType.section1.description')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionButton, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              onClick: function onClick() {
                return router.push({
                  pathname: constants/* ROUTES.TRAININGS */.Z6.TRAININGS
                });
              },
              whiteType: true,
              text: t('about.coursesType.section1.button')
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingTypes_elements_Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TrainingTypes_elements_SectionHeader, {
            children: t('about.coursesType.section2.label')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingTypes_elements_SectionDescription, {
            children: t('about.coursesType.section2.description')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionButton, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              onClick: function onClick() {
                return router.push({
                  pathname: constants/* ROUTES.COMPANY_COURSES */.Z6.COMPANY_COURSES
                });
              },
              whiteType: true,
              text: t('about.coursesType.section2.button')
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var TrainingTypes = (TrainingTypesTemplate);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
;// CONCATENATED MODULE: ./src/pages/o-firme.tsx

















var AboutUs = function AboutUs() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.about.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "about.hero.title",
      imageKey: "about_hero.webp",
      descriptionKey: "about.hero.paragraph"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyValues, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingTypes, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Education, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Customers_Customers, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Clients/* default */.Z, {
      titleKey: 'about.partners.title',
      showPartners: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var o_firme = (AboutUs);

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-1"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-2"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-3"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-4"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx









var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      descriptionKey = _ref.descriptionKey,
      listKeys = _ref.listKeys;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        dangerouslySetInnerHTML: {
          __html: t(titleKey)
        }
      }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        dangerouslySetInnerHTML: {
          __html: t(descriptionKey)
        }
      }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: t(listKey)
            }
          })]
        }, key);
      }))]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 79094:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-firme",
      function () {
        return __webpack_require__(65253);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,9392,6506,9774,2888,179], function() { return __webpack_exec__(79094); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);